import index from '@/views/index/index.vue';
import store from '@/store'
import {POST, POST1} from '@/utils/api'
import dayjs from '@/utils/dayjs'
import router from '@/router/index'
import SparkMD5 from "spark-md5";
import {ElMessageBox, ElMessage, ElCheckbox, ElIcon} from 'element-plus'
import {h, isVNode, ref} from 'vue'
import axios from 'axios';
import openVip from '@/components/openVip.vue'
import {filterSelectedRouteChildren, getPowerCodeWithChildren, hasSelectedPower} from '@/utils/powerTree'
import {registerActivePage} from '@/utils/activePageSession'
import {readStoredLoginContext} from '@/utils/tokenLifecycle'

let tools;
export default tools = {

    /**
     * 上传文件到七牛云
     */
    uploadFileToQiniu(file) {
        let that = this;
        return new Promise(function (resolve, reject) {
            //获取md5
            let fileReader = new FileReader();
            let Spark = new SparkMD5.ArrayBuffer();
            fileReader.readAsArrayBuffer(file.raw);
            fileReader.onload = function (e) {
                Spark.append(e.target.result);
                let md5 = Spark.end();
                //设置md5
                file.md5 = md5;
                //设置uuid
                file.uuid = that.getUUID();

                //获取上传图片的token
                let param = [{
                    "shopId": store.state.shopInfo.id,
                    "companyId": store.state.companyInfo.companyId,
                    "fileByteSize": file.size,
                    "fileName": file.name,
                    "md5": file.md5,
                    "uuid": file.uuid,
                }];
                POST("/customer/EomsOssResource/upload", param).then(res => {
                    file.masterKey = res.data[0].masterKey;
                    file.masterToken = res.data[0].masterToken;
                    file.resourceId = res.data[0].resourceId;
                    file.resourceLogId = res.data[0].resourceLogId;
                    file.uploadStatus = 2;
                    //开始上传文件
                    that.sendFileState(file).then(res => {
                        const formData = new FormData();
                        formData.append('key', file.masterKey);
                        formData.append('token', file.masterToken);
                        formData.append('file', file.raw);
                        axios.post('https://upload-z2.qiniup.com', formData, {
                            headers: {'Content-Type': 'multipart/form-data'}
                        }).then(response => {
                            //调用上传状态
                            file.uploadStatus = 0;
                            that.sendFileState(file).then(res => {
                                resolve(res);
                            });
                        }).catch(error => {
                            //调用上传状态
                            file.uploadStatus = 1;
                            that.sendFileState(file).then(res => {
                                reject(error);
                            });

                        });
                    });
                })

            };
        });
    },

    /**
     * 发送上传文件状态 state状态: 0-成功，1-失败，2-进行中
     */
    sendFileState(file) {
        return new Promise(function (resolve, reject) {
            let param = {
                "resourceId": file.resourceId,
                "resourceLogId": file.resourceLogId,
                "uploadStatus": file.uploadStatus,
                "byteSize": file.size
            };
            POST("/customer/EomsOssResource/upload/update/status", param, false).then(res => {
                resolve(res);
            }).catch(err => {
                resolve();
            })
        });
    },

    /**
     * 获取指定序号的列
     */
    getIndex(column, prop) {
        for (let i = 0; i < column.length; i++) {
            if (column[i].prop == prop) {
                return column[i]
            }
        }
    },

    async switchShopCore(currShopId) {
        return this.switchShop(currShopId);
    },

    /**
     * 处理订单更新冲突
     * 5201: 订单已被修改，用户点击更新后重新拉取订单
     * 5202: 订单已被删除，用户确认后返回上一页
     */
    async handleOrderUpdateException(err, options = {}) {
        if (!err || (Number(err.code) !== 5201 && Number(err.code) !== 5202)) {
            return false;
        }
        const message = err.msg || (Number(err.code) === 5201 ? "订单已被修改，请刷新后重试！" : "订单已被删除！");

        if (Number(err.code) === 5201) {
            try {
                await ElMessageBox.confirm(message, "提示", {
                    confirmButtonText: "立即刷新",
                    cancelButtonText: "取消",
                    type: "warning",
                });
                if (typeof options.onRefresh === "function") {
                    await options.onRefresh(err);
                }
            } catch (e) {
                // 用户取消，不做额外处理
            }
            return true;
        }

        await ElMessageBox.alert(message, "提示", {
            confirmButtonText: "确定",
            type: "warning",
        });
        if (typeof options.onBack === "function") {
            await options.onBack(err);
        }
        return true;
    },

    /**
     * 查询权限字段
     * @param powerList
     * @param pageName
     * @returns {*|null}
     */
    findPagePowerConfig(powerList = store.state.powerList, pageName = store.state.currRouter.name) {
        if (!powerList || !pageName) {
            return null;
        }
        for (let i = 0; i < powerList.length; i++) {
            if (powerList[i].logicName == pageName) {
                return powerList[i];
            }
            if (powerList[i].powerList && powerList[i].powerList.length > 0) {
                let pagePower = this.findPagePowerConfig(powerList[i].powerList, pageName);
                if (pagePower) {
                    return pagePower;
                }
            }
        }
        return null;
    },

    /**
     * 校验订单详情字段权限
     * @param row
     * @param powerList
     * @returns {*}
     */
    checkDescPower(row, powerList = store.state.powerList, pageName = store.state.currRouter.name) {
        if (!Array.isArray(row) || row.length === 0) {
            return row;
        }
        const pageNames = Array.isArray(pageName) ? pageName : [pageName];
        let pagePower = null;
        for (let i = 0; i < pageNames.length; i++) {
            if (!pageNames[i]) {
                continue;
            }
            let tempPower = this.findPagePowerConfig(powerList, pageNames[i]);
            if (tempPower && tempPower.tableFieldList && tempPower.tableFieldList.length > 0) {
                pagePower = tempPower;
                break;
            }
        }
        if (!pagePower || !pagePower.tableFieldList || pagePower.tableFieldList.length === 0) {
            return row;
        }
        return row.filter(item => {
            if (!item || item.isPower === false || !item.prop) {
                return true;
            }
            let prop = item.prop.replaceAll("_", "").toUpperCase();
            for (let i = 0; i < pagePower.tableFieldList.length; i++) {
                let field = pagePower.tableFieldList[i];
                if (field.fieldLogicName) {
                    let fieldLogicName = field.fieldLogicName.replaceAll("_", "").toUpperCase();
                    if (fieldLogicName == prop) {
                        return !!field.isSelected;
                    }
                }
            }
            return true;
        });
    },

    /**
     * 校验table列的权限
     */
    checkTablePower(column, powerList = store.state.powerList) {
        //校验权限
        let pagesName = store.state.currRouter.name;
        for (let i = 0; i < powerList.length; i++) {
            if (pagesName == powerList[i].logicName) {
                for (let k = 0; k < column.length; k++) {
                    let flag = 0;
                    //循环判断是否有此列
                    for (let j = 0; j < powerList[i].tableFieldList.length; j++) {
                        if (powerList[i].tableFieldList[j].fieldLogicName && powerList[i].tableFieldList[j].isSelected
                            && column[k].label && column[k].prop) {
                            let fieldLogicName = powerList[i].tableFieldList[j].fieldLogicName.replaceAll("_", "").toUpperCase();
                            let prop = column[k].prop.toUpperCase();
                            if (fieldLogicName == prop) {
                                flag++;
                            }
                        }
                    }
                    //如果没有此列,说明没有权限,visible设置false, 说明:show是控制显示列,visible控制是否有此列
                    if (flag == 0 && column[k].type != "selection" && column[k].type != "index" && column[k].type != "button") {
                        //isPower为false 不校验
                        if (column[k].isPower == false) {

                        } else {
                            column[k].visible = false;
                        }
                    }
                }
            }
            if (powerList[i].powerList && powerList[i].powerList.length > 0) {
                column = this.checkTablePower(column, JSON.parse(JSON.stringify(powerList[i].powerList)))
            }
        }
        //校验用户自定义的隐藏
        let columnSet = localStorage.getItem("column_" + store.state.currRouter.name + "_" + store.state.userInfo.id);
        if (columnSet) {
            try {
                columnSet = JSON.parse(columnSet);
                for (let i = 0; i < columnSet.length; i++) {
                    for (let j = 0; j < column.length; j++) {
                        if (columnSet[i].label == column[j].label && columnSet[i].prop == column[j].prop) {
                            column[j].show = columnSet[i].show;
                        }
                    }
                }
            } catch (e) {
                console.error("解析自定义隐藏列错误", e)
            }
        }
        return column;
    },

    /**
     * 页面按钮鉴权指令
     * @description v-access="'001001'", 001001为权限码
     */
    accessDirective(app) {
        app.directive('access', {
            mounted(el, binding) {
                if (tools.getPowerCode(store.state.powerList, binding.value) == null) {
                    el.remove();
                }
            },
        })
    },

    /**
     * 按钮防抖鉴权指令
     */
    antiShakeDirective(app) {
        app.directive('antiShake', {
            mounted(el, binding) {
                let timer = null;
                el.addEventListener('click', () => {
                    let firstClick = !timer;
                    if (firstClick) {
                        binding.value()
                    }
                    if (timer) {
                        clearTimeout(timer)
                    }
                    timer = setTimeout(() => {
                        timer = null;
                    }, 500);
                })
            }
        });
    },

    /**
     * 防抖函数
     * @param {Function} fn 需要执行的方法
     * @param {Number} wait 间隔时间，默认500ms
     * @param {Boolean} immediate 是否立即执行
     * @returns {Function}
     */
    debounce(fn, wait = 500, immediate = false) {
        let timer = null;

        function debounced() {
            const context = this;
            const args = arguments;

            if (timer) {
                clearTimeout(timer);
            }

            if (immediate) {
                const callNow = !timer;

                timer = setTimeout(() => {
                    timer = null;
                }, wait);

                if (callNow) {
                    return fn.apply(context, args);
                }
            } else {
                timer = setTimeout(() => {
                    fn.apply(context, args);
                    timer = null;
                }, wait);
            }
        }

        debounced.cancel = function () {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };

        return debounced;
    },

    /**
     * 节流函数
     * @param {Function} fn 需要执行的方法
     * @param {Number} wait 间隔时间，默认500ms
     * @returns {Function}
     */
    throttle(fn, wait = 500) {
        let timer = null;
        let lastTime = 0;

        function throttled() {
            const context = this;
            const args = arguments;
            const now = Date.now();
            const remaining = wait - (now - lastTime);

            if (remaining <= 0 || remaining > wait) {
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }

                lastTime = now;
                return fn.apply(context, args);
            }

            if (!timer) {
                timer = setTimeout(() => {
                    lastTime = Date.now();
                    timer = null;
                    fn.apply(context, args);
                }, remaining);
            }
        }

        throttled.cancel = function () {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            lastTime = 0;
        };

        return throttled;
    },
    /**
     * 获取集合中是否存在指定code
     */
    getPowerCode(list, code) {
        return getPowerCodeWithChildren(list, code);
    },

    /**
     * 获取集合中选中的ids
     */
    getPowerCheckedKeys(list, keys) {
        list.forEach(item => {
            if (item.isSelected) {
                keys.push(item.id);
            }
            if (item.powerList.length > 0) {
                keys = this.getPowerCheckedKeys(item.powerList, keys);
            }
        });
        return keys;
    },

    /**
     * proxy对象转普通对象
     */
    getObjData(object) {
        let form = {};
        Object.keys(object).forEach(key => {
            form[key] = object[key];
        });
        return form
    },

    /**
     * proxy对象转formData
     */
    getFormData(object) {
        let formData = new FormData();
        Object.keys(object).forEach(key => {
            formData.append(key, object[key]);
        });
        return formData
    },

    /**
     * 获取页面查询limit
     */
    getLimit(page) {
        try {
            let pageLimit = localStorage.getItem("pageLimit");
            if (pageLimit) {
                let limitArr = pageLimit.split(",");
                for (let i = 0; i < limitArr.length; i++) {
                    if (limitArr[i].indexOf(page) > -1) {
                        return parseInt(limitArr[i].split("|")[1])
                    }
                }
            }

        } catch (err) {
            console.log("limit解析错误", err)
        }
        return 15;
    },

    /**
     * 保存页面查询limit
     */
    setLimit(page, value) {
        try {
            let item = page + "|" + value;
            let limitArr;
            let pageLimit = localStorage.getItem("pageLimit");
            if (pageLimit) {
                limitArr = pageLimit.split(",");
                let flag = 0;
                for (let i = 0; i < limitArr.length; i++) {
                    //判断是否存在
                    if (limitArr[i].indexOf(page) > -1) {
                        limitArr[i] = item;
                        flag++;
                    }
                }
                if (flag == 0) {
                    limitArr.push(item);
                }
            } else {
                limitArr = [item]
            }
            console.log("pageLimit", limitArr)

            localStorage.setItem("pageLimit", limitArr.join(","))
        } catch (err) {
            console.log("limit保存解析错误", err)
        }
    },

    /**
     * 切换门店 currShopId:传入上一次切换的shopId,如果没有是-1
     */
    async switchShop(currShopId) {
        let index = 0;
        if (store.state.companyInfo.shopList && store.state.companyInfo.shopList.length > 0) {
            for (let i = 0; i < store.state.companyInfo.shopList.length; i++) {
                if (store.state.companyInfo.shopList[i].id == currShopId) {
                    index = i;
                }
            }
            let shopInfo = store.state.companyInfo.shopList[index];
            shopInfo.currShop = index;
            shopInfo.vipTime = null;
            shopInfo.startVipTime = null;
            store.commit("setShopInfo", shopInfo);
            localStorage.setItem("currShopId", shopInfo.id);
            // 获取VIP弹窗到期状态,余额不足弹窗状态
            let {vipDialog7Status, walletDialog7Status, screenDialog7Status} = await this.queryDialogState() || {}

            //验证当前登录人员登录是否到期
            // POST("/author/EomsUser/session/reset", {shopId: shopInfo.id}).then(res => {
            // })

            //获取门店vip信息
            POST("/customer/EomsShop/level", {shopId: shopInfo.id}).then(res => {
                //重新设置vip时间
                if (res.data.level == 1) {
                    shopInfo.vipTime = dayjs(res.data.endDate).format("YYYY-MM-DD");
                    //vip开始时间
                    shopInfo.startVipTime = dayjs(res.data.startDate).format("YYYY-MM-DD hh:mm:ss");
                    store.commit("setShopInfo", shopInfo);
                    //如果15天内到期
                    let isTip = localStorage.getItem(currShopId + "_vipTip");
                    if (isTip && isTip == dayjs().format("YYYY-MM-DD")) {
                    } else {
                        if (dayjs().isAfter(dayjs(res.data.endDate).subtract(30, 'day')) && !vipDialog7Status) {
                            const checkboxValue = ref(false)

                            const MessageBoxWithRadio = {
                                render() {
                                    return h('div', {style: {paddingBottom: '10px', fontSize: '16px'}}, [
                                        h('p', {
                                            style: {
                                                textAlign: 'right',
                                                marginBottom: '10px'
                                            }
                                        }, `您的VIP${shopInfo.vipTime}到期,请及时续费!`),
                                        h(
                                            ElCheckbox,
                                            {
                                                modelValue: checkboxValue.value,
                                                'onUpdate:modelValue': val => (checkboxValue.value = val),
                                                style: {marginTop: '8px'}
                                            },
                                            () => '7天内不再提示'
                                        )
                                    ])
                                }
                            }

                            // 弹窗调用
                            ElMessageBox({
                                title: '到期提醒',
                                message: h(MessageBoxWithRadio),
                                showCancelButton: false,
                                confirmButtonText: '续费',
                                center: false,
                                beforeClose: (action, instance, done) => {
                                    if (checkboxValue.value) {
                                        this.handleUpdateDialogState('vipDialog7Status', checkboxValue.value)
                                    }
                                    done() // 不需要验证，直接关闭

                                }
                            })
                                .then(() => {
                                    //开启续费会员
                                    window.$openVip.initData()
                                })
                            localStorage.setItem(currShopId + "_vipTip", dayjs().format("YYYY-MM-DD"))
                        }
                    }

                }

                //重新设置钱包提示
                if (res.data.isUseQiniuOss == 1) {
                    let isTip = localStorage.getItem(currShopId + "_ossTip");
                    if (isTip && isTip == dayjs().format("YYYY-MM-DD")) {
                    } else {
                        if (res.data.balance <= 3000 && !walletDialog7Status) {

                            const checkboxValue = ref(false)

                            const MessageBoxWithRadio = {
                                render() {
                                    return h('div', {style: {paddingBottom: '0px', fontSize: '16px'}}, [
                                        h('p', {
                                            style: {
                                                textAlign: 'right',
                                            }
                                        }, `钱包余额不足,为了不影响精彩瞬间等功能使用`),
                                        h('p', {
                                            style: {
                                                textAlign: 'left',
                                                marginBottom: '10px'
                                            }
                                        }, '请尽快充值!'),
                                        h(
                                            ElCheckbox,
                                            {
                                                modelValue: checkboxValue.value,
                                                'onUpdate:modelValue': val => (checkboxValue.value = val),
                                                style: {marginTop: '8px'}
                                            },
                                            () => '7天内不再提示'
                                        )
                                    ])
                                }
                            }

                            // 弹窗调用
                            ElMessageBox({
                                title: '重要通知',
                                message: h(MessageBoxWithRadio),
                                showCancelButton: false,
                                confirmButtonText: '充值',
                                center: false,
                                beforeClose: (action, instance, done) => {
                                    if (checkboxValue.value) {
                                        this.handleUpdateDialogState('walletDialog7Status', checkboxValue.value)
                                    }
                                    done() // 不需要验证，直接关闭
                                }
                            })
                                .then(() => {

                                    let param = {
                                        key: "momentList",
                                        value: {
                                            show: true
                                        }
                                    };
                                    store.commit("routerParam", param);
                                    router.push({name: 'momentList'});
                                    //开启续费会员
                                })
                            localStorage.setItem(currShopId + "_ossTip", dayjs().format("YYYY-MM-DD"))
                        }
                    }

                }

                if (res.data.screenEndDate) {
                    const today = dayjs().format("YYYY-MM-DD");
                    const tipKey = currShopId + "_screenTip";
                    const tipValue = localStorage.getItem(tipKey);
                    const endDate = dayjs(res.data.screenEndDate);
                    if (endDate.isValid()
                        && tipValue !== `${today}_${res.data.screenEndDate}`
                        && dayjs().isAfter(endDate.subtract(30, 'day'))
                        && !screenDialog7Status) {

                        const checkboxValue = ref(false)
                        const remainDays = endDate.startOf('day').diff(dayjs().startOf('day'), 'day');
                        const remindText = remainDays < 0
                            ? `您的投屏服务已于${endDate.format("YYYY-MM-DD")}到期，请及时处理`
                            : `您的投屏服务将于${endDate.format("YYYY-MM-DD")}到期，请及时处理`;

                        const MessageBoxWithRadio = {
                            render() {
                                return h('div', {style: {paddingBottom: '10px', fontSize: '16px'}}, [
                                    h('p', {
                                        style: {
                                            textAlign: 'right',
                                            marginBottom: '10px'
                                        }
                                    }, remindText),
                                    h(
                                        ElCheckbox,
                                        {
                                            modelValue: checkboxValue.value,
                                            'onUpdate:modelValue': val => (checkboxValue.value = val),
                                            style: {marginTop: '8px'}
                                        },
                                        () => '7天内不再提示'
                                    )
                                ])
                            }
                        }

                        const openVipOptions = {
                            businessType: 2,
                            shopId: store.state.shopInfo.id,
                            companyId: store.state.companyInfo.companyId,
                            onClose: () => {
                                this.switchShopCore(currShopId);
                            }
                        };

                        ElMessageBox({
                            title: '到期提醒',
                            message: h(MessageBoxWithRadio),
                            showCancelButton: false,
                            confirmButtonText: '去开通',
                            center: false,
                            beforeClose: (action, instance, done) => {
                                if (checkboxValue.value) {
                                    this.handleUpdateDialogState('screenDialog7Status', checkboxValue.value)
                                }
                                done()
                            }
                        }).then(() => {
                            if (window.$openVip && window.$openVip.initData) {
                                window.$openVip.initData(openVipOptions);
                            } else {
                                store.commit("routerParam", {
                                    key: "noticeVip",
                                    value: {
                                        ...openVipOptions,
                                        autoOpen: true,
                                    }
                                });
                                router.push({name: 'noticeVip'});
                            }
                        }).finally(() => {
                            localStorage.setItem(tipKey, `${today}_${res.data.screenEndDate}`)
                        })
                    }
                }

            })
        } else {
            let shopInfo = {
                companyId: -1,
                currShop: 0,
                id: -1,
                shopAddress: "",
                shopName: "暂无店铺",
                state: 0
            };
            store.commit("setShopInfo", shopInfo);
            localStorage.setItem("currShopId", -1);
        }
    },

    /**
     * 查询弹窗状态
     */
    queryDialogState() {
        return new Promise(resolve => {
            POST('/customer/EomsShop/shop/dialog/show', {})
                .then(res => {
                    resolve(res.data) //
                })
                .catch(err => {
                    console.error('接口请求失败:', err)
                    resolve(null) //
                })
        })
    },

    /**
     *
     * 设置弹窗7天不显示
     */
    handleUpdateDialogState(key, data) {
        let params = {
            [key]: data
        }
        POST('/customer/EomsShop/shop/dialog/show/update', params)
            .then(res => {
            })
            .catch(err => {
                console.error('接口请求失败:', err)
            })
    },
    /**
     * 设置页面uuid
     */
    setActivePageUUID() {
        const uuid = store.state.activePageUUID || this.getUUID();
        store.commit("setActivePageUUID", uuid);
        return registerActivePage({
            uuid,
            request: value => POST1("/author/EomsUser/setActivePage", {activePageUUID: value}, false),
        });
    },

    /**
     * 设置信息
     */
    setInfo: function () {
        return new Promise((resolve, reject) => {
            let loginContext;
            try {
                loginContext = readStoredLoginContext(localStorage);
            } catch (e) {
                reject(e);
                return;
            }

            //设置页面uuid，同时让后端校验当前token
            this.setActivePageUUID().then(res => {
                //初始化菜单
                this.initMenu(loginContext.functionPowers);
                //设置用户信息
                store.commit("setUserInfo", loginContext.userInfo);
                //设置当前公司员工信息
                store.commit("setCompanyUser", loginContext.companyUser ? loginContext.companyUser : {});
                //设置公司信息
                store.commit("setCompanyInfo", loginContext.companyInfo);
                //设置系统参数
                store.commit("setSysParam", loginContext.sysParam);
                //设置权限信息
                store.commit("setPowerList", loginContext.functionPowers);
                //设置切换门店
                this.switchShop(localStorage.getItem("currShopId") ? localStorage.getItem("currShopId") : -1);
                resolve();
            }).catch(e => {
                reject(e);
            })
        });
    },

    /**
     * 初始化菜单
     */
    initMenu: function (functionPowers) {
        if (!functionPowers) {
            return;
        }
        //设置路由
        let menuList = [
            {
                path: '/index/home',
                name: 'home',
                meta: {
                    show: false,
                    title: localStorage.getItem("homepage") ? localStorage.getItem("homepage") : '房间',
                    icon: 'el-icon-s-home'
                },
                component: () => import('@/views/index/home')
            },
            {
                path: '/index/userInfo',
                name: 'userInfo',
                meta: {
                    show: false,
                    title: '个人信息',
                    icon: 'el-icon-s-home'
                },
                component: () => import('@/views/index/userInfo')
            },
            {
                path: '/index/noticeVip',
                name: 'noticeVip',
                meta: {
                    show: false,
                    title: '开通会员',
                    icon: 'el-icon-s-home'
                },
                component: () => import('@/views/index/noticeVip')
            },
            //不显示置顶菜单,因为后台表中没有填写,这里单独配置的,后台表中填写的,不显示的二级菜单可以在setMenu里设置
            {
                path: '/companyManage/roleManagePower',
                name: 'roleManagePower',
                meta: {
                    show: false,
                    title: '分配权限',
                    icon: 'el-icon-s-home'
                },
                component: () => import('@/views/companyManage/roleManagePower')
            },
        ];

        menuList = this.setMenu(menuList, functionPowers);
        let home = {
            path: '/',
            name: 'index',
            redirect: '/home',
            component: index,
            children: menuList
        };
        //添加
        router.addRoute(home);

        //添加到菜单
        store.commit("setMenuList", menuList);

    },

    /**
     * 设置菜单
     */
    setMenu(menuList, funcList) {
        const supportThirdLevelSet = new Set(['002999']); // 仅允许这些 code 为三级结构

        funcList.forEach(first => {
            // 表单管理（ID 205）及其子权限不生成菜单路由。
            if (first.powerCode === '020') return;

            if (hasSelectedPower(first) && first.powerCode.length === 3) {
                const item = {
                    path: first.logicName,
                    name: first.logicName,
                    meta: {
                        show: first.isShowMenu === 1,
                        title: first.displayName,
                        code: first.powerCode,
                        icon: first.icon,
                        type: first.powerType,
                    },
                    children: [],
                };

                if (Array.isArray(first.powerList) && first.powerList.length > 0) {
                    const subMenus = this.setSecedeMenu(
                        first.powerList,
                        first.powerCode,
                        first.logicName,
                        supportThirdLevelSet
                    );
                    item.children = subMenus;
                }

                menuList.push(item);
            }
        });

        return menuList;
    },
    setSecedeMenu(funcList, parentPowerCode, basePath, supportThirdLevelSet) {
        const result = [];

        funcList.forEach(func => {
            if (!hasSelectedPower(func) || !func.routePath) return;

            const isThirdLevelGroup = supportThirdLevelSet.has(func.powerCode);

            // 如果支持三级
            if (isThirdLevelGroup && Array.isArray(func.powerList) && func.powerList.length > 0) {
                const parentItem = {
                    // path: func.logicName,
                    path: func.logicName,
                    name: func.logicName,
                    meta: {
                        show: func.isShowMenu === 1,
                        title: func.displayName,
                        code: func.powerCode,
                        icon: func.icon,
                        type: func.powerType,
                    },
                    // component: { render: () => h('router-view') },
                    children: filterSelectedRouteChildren(func.powerList)
                        .map(child => ({
                            path: `/${basePath}/${func.logicName}/${child.logicName}`,
                            name: child.logicName,
                            meta: {
                                show: child.isShowMenu === 1,
                                title: child.displayName,
                                code: child.powerCode,
                                icon: child.icon,
                            },
                            component: () => import("@/views" + child.routePath),
                        })),
                };

                result.push(parentItem);
            } else {
                // 非三级结构或不在支持列表中：将自身作为二级菜单
                result.push({
                    path: `/${basePath}/${func.logicName}`,
                    name: func.logicName,
                    meta: {
                        show: func.isShowMenu === 1,
                        title: func.displayName,
                        code: func.powerCode,
                        icon: func.icon,
                        type: func.powerType,
                    },
                    component: () => import("@/views" + func.routePath),
                });

                // 如果有 children，把它们也当成二级菜单放进去（平铺）
                if (Array.isArray(func.powerList)) {
                    func.powerList.forEach(child => {
                        if (!hasSelectedPower(child) || !child.routePath) return;

                        result.push({
                            path: `/${basePath}/${child.logicName}`,
                            name: child.logicName,
                            meta: {
                                show: child.isShowMenu === 1,
                                title: child.displayName,
                                code: child.powerCode,
                                icon: child.icon,
                            },
                            component: () => import("@/views" + child.routePath),
                        });
                    });
                }
            }
        });

        return result;
    },
    /**
     * 设置tabList
     */
    settingTabList: function (to) {
        //设置当前路由,并存如缓存
        store.commit("setCurrRouter", to);
        localStorage.setItem('routerName', to.name);
        //判断tabList
        let tabList = store.state.tabList;
        let flag = 0;
        //循环判断,如果当前页已加入tab集合则不加入
        for (let i = 0; i < tabList.length; i++) {
            if (tabList[i].name == to.name) {
                flag = 1;
            }
        }
        //如果跳转页面是一下页面,则不需要加入tab集合
        if (to.name == 'login' || to.name == 'home' || to.name == '404') {
            flag = 2;
        }
        if (flag === 0) {
            tabList.push(to);
            store.commit("setTabList", tabList);
        }
    },

    /**
     * 关闭当前路由界面
     * backRouterName: 关闭后返回的路由name
     */
    closeCurrRouter(backRouterName) {
        let tabList = store.state.tabList;
        let currRouter = store.state.currRouter;
        //判断关闭后显示页面
        for (let i = 0; i < tabList.length; i++) {
            if (tabList[i].name == currRouter.name) {
                tabList.splice(i, 1);
                i--;
                if (tabList.length > 0 && tabList[i] && tabList[i].name) {
                    router.push({name: backRouterName});
                } else {
                    router.push({name: 'home'});
                }
            }
        }
    },

    /**
     * 设置当前tab名称
     */
    setTabTitle(title) {
        let tabList = store.state.tabList;
        for (let i = 0; i < tabList.length; i++) {
            if (tabList[i].name == store.state.currRouter.name) {
                tabList[i].meta.title = title;
                return;
            }
        }
    },

    /**
     * 分钟转时间
     */
    minToTime(val) {
        let time = [];
        let day = parseInt(val / 60 / 24);
        let hour = parseInt(val / 60 % 24);
        let min = parseInt(val % 60);
        time[0] = day > 0 ? day : '00';
        time[1] = hour > 0 ? hour : '00';
        time[2] = min > 0 ? min : '00';
        return time;
    },

    /**
     * 秒数转化为时分秒
     */
    formatSeconds(value) {
        let secondTime = parseInt(value);// 秒
        let minuteTime = 0;// 分
        let hourTime = 0;// 小时
        if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取余，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取余的分，获取分钟除以60取余的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        let result = secondTime > 9 ? secondTime : "0" + secondTime;
        result = (minuteTime > 9 ? minuteTime : "0" + minuteTime) + ":" + result;
        result = (hourTime > 9 ? hourTime : "0" + hourTime) + ":" + result;
        return result;
    },

    /**
     * 时间戳(10位)转时间格式
     */
    intervalTime(timeDiff) {
        // 计算小时数
        let hours = Math.floor(Math.floor(timeDiff) / (3600));
        // 计算去除小时剩余的秒
        let leavel1 = timeDiff % (3600);
        // 计算剩余的分钟数
        let minutes = Math.floor(leavel1 / (60));
        // 计算去除分钟剩余秒
        let second = Math.floor(leavel1 % (60));

        if (hours >= 0 && hours <= 9) {
            hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (second >= 0 && second <= 9) {
            second = "0" + second;
        }
        return {
            hours: hours,
            minutes: minutes,
            second: second
        }
    },

    /**
     ** 加法函数，用来得到精确的加法结果
     ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
     ** 调用：accAdd(arg1,arg2)
     ** 返回值：arg1加上arg2的精确结果
     **/
    accAdd: function (arg1, arg2) {
        arg1 = arg1 ? arg1 : 0;
        arg2 = arg2 ? arg2 : 0;
        var r1, r2, m, c;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
            var cm = Math.pow(10, c);
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""));
                arg2 = Number(arg2.toString().replace(".", "")) * cm;
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm;
                arg2 = Number(arg2.toString().replace(".", ""));
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
    },

    /**
     ** 减法函数，用来得到精确的减法结果
     ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
     ** 调用：accSub(arg1,arg2)
     ** 返回值：arg1加上arg2的精确结果
     **/
    accSub: function (arg1, arg2) {
        arg1 = arg1 ? arg1 : 0;
        arg2 = arg2 ? arg2 : 0;
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },

    /**
     ** 乘法函数，用来得到精确的乘法结果
     ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
     ** 调用：accMul(arg1,arg2)
     ** 返回值：arg1乘以 arg2的精确结果
     **/
    accMul: function (arg1, arg2) {
        arg1 = arg1 ? arg1 : 0;
        arg2 = arg2 ? arg2 : 0;
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        } catch (e) {
        }
        try {
            m += s2.split(".")[1].length;
        } catch (e) {
        }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },

    /**
     ** 除法函数，用来得到精确的除法结果
     ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
     ** 返回值：arg1除以arg2的精确结果
     **/
    accDiv: function (arg1, arg2) {
        arg1 = arg1 ? arg1 : 0;
        arg2 = arg2 ? arg2 : 0;
        var t1 = 0, t2 = 0, r1, r2;
        try {
            t1 = arg1.toString().split(".")[1].length;
        } catch (e) {
        }
        try {
            t2 = arg2.toString().split(".")[1].length;
        } catch (e) {
        }
        r1 = Number(arg1.toString().replace(".", ""));
        r2 = Number(arg2.toString().replace(".", ""));
        return (r1 / r2) * Math.pow(10, t2 - t1);
    },

    /**
     * 金额等分 + 最后一笔补差（使用本工具的四则运算实现精确计算）
     */
    calcCumulativePay: function (total, count, playerNum) {

        // 真实单价（不截断）
        const unitReal = total / count;

        // 累计金额 = 单价 × 次数（不截断）
        const cumulative = unitReal * playerNum;

        // 最后统一截断到两位小数
        return Math.floor(cumulative * 100) / 100;
    },

    /**
     * 生成UUID
     */
    getUUID() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }

        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }
    ,

    /**
     * 通用字段校验函数
     * @param {Object} form - 表单数据对象
     * @param {Object} rules - 校验字段及提示语，如 { createTime: '请选择时间' }
     * @returns {Boolean} - 是否通过校验
     */
    validateFields(form, rules) {
        for (const key in rules) {
            const value = form[key];

            const isEmptyArray = Array.isArray(value) && value.every(item => item === null || item === '' || item === undefined);
            const isEmptyValue = value === null || value === '' || value === undefined;

            if (isEmptyArray || isEmptyValue) {
                ElMessage({
                    type: 'warning',
                    message: rules[key],
                });
                return false;
            }
        }
        return true;
    }
    ,

    /**
     * 可编辑 & 全事件暴露的 MessageBox 封装
     * @param {Object} options
     * @param {string} [options.title] - 弹窗标题
     * @param {string|VNode} options.message - 弹窗内容
     * @param {boolean} [options.showCancelButton] - 是否显示取消按钮
     * @param {string} [options.confirmButtonText] - 确认按钮文案
     * @param {string} [options.cancelButtonText] - 取消按钮文案
     * @param {function} [options.beforeClose] - 关闭前回调 (action, instance, done)
     * @param {function} [options.onConfirm] - 点击确认时回调
     * @param {function} [options.onCancel] - 点击取消时回调
     * @param {function} [options.onClose] - 点击右上角关闭按钮时回调
     * @param {object} [options.elOptions] - 透传给 ElMessageBox 的其他配置
     */
    showCustomMessageBox(options) {
        const {
            title = '提示',
            message,
            icon,              // 可选，传一个 Element Plus 图标组件
            iconColor = '#409EFF', // 图标颜色
            iconSize = '20px', // 图标大小
            showCancelButton = true,
            confirmButtonText = '确定',
            cancelButtonText = '取消',
            beforeClose,
            onConfirm,
            onCancel,
            onClose,
            elOptions = {}
        } = options

        let finalMessage
        if (icon) {
            finalMessage = h('div', {style: 'display: flex; align-items: center;'}, [
                h(ElIcon, {style: `color: ${iconColor}; font-size: ${iconSize}; margin-right: 8px;`}, () => h(icon)),
                isVNode(message) ? message : h('span', message)
            ])
        } else {
            finalMessage = message
        }

        return ElMessageBox({
            title,
            message: finalMessage,
            showCancelButton,
            confirmButtonText,
            cancelButtonText,
            closeOnClickModal: false,
            distinguishCancelAndClose: true,
            ...elOptions,
            beforeClose: (action, instance, done) => {
                if (beforeClose) {
                    beforeClose(action, instance, done)
                } else {
                    done()
                }
            }
        })
            .then(() => {
                onConfirm && onConfirm()
            })
            .catch((err) => {
                if (err === 'cancel') {
                    onCancel && onCancel()
                } else if (err === 'close') {
                    onClose && onClose()
                }
            })
    }
}
